import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiUser, FiLogOut, FiFileText, FiList, FiBriefcase, FiKey } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';

const Header = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userMenuRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleResetPassword = () => {
    setShowUserMenu(false);
    navigate('/reset-password');
  };

  // 点击外部关闭菜单
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background">
      <div className="container mx-auto px-4 max-w-7xl flex h-16 items-center justify-between">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center space-x-2">
            <FiFileText className="h-6 w-6" />
            <span className="font-bold text-xl">LLM Interview Assistant</span>
          </Link>

          {isAuthenticated && (
            <nav className="hidden md:flex items-center space-x-4 lg:space-x-6">
              <Link
                to="/evaluations"
                className="text-sm font-medium transition-colors hover:text-primary flex items-center"
              >
                <FiList className="mr-2" />
                评估记录
              </Link>
              <Link
                to="/evaluate"
                className="text-sm font-medium transition-colors hover:text-primary flex items-center"
              >
                <FiFileText className="mr-2" />
                评估简历
              </Link>
              <Link
                to="/jds"
                className="text-sm font-medium transition-colors hover:text-primary flex items-center"
              >
                <FiBriefcase className="mr-2" />
                管理JD
              </Link>
            </nav>
          )}
        </div>

        <div className="flex items-center gap-4">
          {isAuthenticated ? (
            <div className="flex items-center gap-4">
              <div className="text-sm text-muted-foreground">
                本月剩余评估次数: {user?.evaluation_count || 0}/{user?.evaluation_limit || 10}
              </div>
              <div className="relative" ref={userMenuRef}>
                <button
                  className="flex items-center gap-2 p-2 rounded-md hover:bg-accent"
                  onClick={() => setShowUserMenu(!showUserMenu)}
                >
                  <FiUser className="h-4 w-4" />
                  <span className="text-sm font-medium">{user?.username || user?.email}</span>
                </button>

                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-48 py-1 bg-background rounded-md shadow-lg border z-50">
                    <button
                      onClick={handleResetPassword}
                      className="flex items-center w-full px-4 py-2 text-sm text-left hover:bg-accent"
                    >
                      <FiKey className="mr-2 h-4 w-4" />
                      重置密码
                    </button>
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-2 text-sm text-left text-destructive hover:bg-accent"
                    >
                      <FiLogOut className="mr-2 h-4 w-4" />
                      退出
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-4">
              <Link
                to="/login"
                className="text-sm font-medium hover:underline"
              >
                登录
              </Link>
              <Link
                to="/register"
                className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700"
              >
                注册
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
